import type { ActivityComponentType } from '@stackflow/react';
import StarredMessagesPage from '@/features/messaging/pages/StarredMessagesPage';

const StarredMessagesActivity: ActivityComponentType = () => (
  <StarredMessagesPage />
);

export default StarredMessagesActivity;
